/**
 * Recorte quadrado centrado (cover) → JPEG.
 * Reutilizado para foto de perfil (size=256) e ícones customizados (size=128).
 */
export function dataUrlToSquareJpeg(dataUrl, size = 256, quality = 0.85) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas')
        canvas.width = size
        canvas.height = size
        const ctx = canvas.getContext('2d')
        if (!ctx) {
          reject(new Error('Canvas indisponível.'))
          return
        }
        const scale = Math.max(size / img.width, size / img.height)
        const dw = img.width * scale
        const dh = img.height * scale
        ctx.drawImage(img, (size - dw) / 2, (size - dh) / 2, dw, dh)
        resolve(canvas.toDataURL('image/jpeg', quality))
      } catch (e) {
        reject(e)
      }
    }
    img.onerror = () => reject(new Error('Imagem inválida.'))
    img.src = dataUrl
  })
}
